var React = require('react');

function SeasongroupIconsSocmedYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.8 1.8c-.2-.9-1-1.7-1.9-1.9-1.7-.4-8.3-.4-8.3-.4S4-.5 2.3-.1C1.4.1.7.9.4 1.8 0 3.5 0 7 0 7s0 3.5.4 5.2c.2.9 1 1.6 1.9 1.9 1.7.4 8.3.4 8.3.4s6.6 0 8.3-.4c.9-.2 1.6-.9 1.9-1.9.4-1.7.4-5.2.4-5.2s0-3.5-.4-5.2zM8.5 10.2V3.8L14 7l-5.5 3.2z","style":{"fillRule":"evenodd","clipRule":"evenodd"},"transform":"translate(0 .5)"}));
}

SeasongroupIconsSocmedYoutube.defaultProps = {"viewBox":"0 0 21.2 15","style":{"enableBackground":"new 0 0 21.2 15"},"xmlSpace":"preserve"};

module.exports = SeasongroupIconsSocmedYoutube;

SeasongroupIconsSocmedYoutube.default = SeasongroupIconsSocmedYoutube;
